import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchRestaurantSearchResults = createAsyncThunk(
  "googlePlaces/fetchRestaurantSearchResults",
  async (query) => {
    const response = await axios.get(`${BASE_URL}/api/places?query=${query}`);
    return response.data;
  }
);

const googlePlacesSlice = createSlice({
  name: "googlePlaces",
  initialState: {
    results: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearRestaurantSearchResults: (state) => {
      state.results = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch restaurant search results
      .addCase(fetchRestaurantSearchResults.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRestaurantSearchResults.fulfilled, (state, action) => {
        state.results = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRestaurantSearchResults.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearRestaurantSearchResults } = googlePlacesSlice.actions;

export default googlePlacesSlice.reducer;
